<template>
    <svg :height="height" :width="width" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24">
        <defs>
            <clipPath id="clip-Arrow_Up_Grey">
                <rect width="24" height="24"/>
            </clipPath>
        </defs>
        <g  id="Arrow_Up_Grey" clip-path="url(#clip-Arrow_Up_Grey)">
            <rect width="24" height="24" fill="rgba(81,91,96,0)"/>
            <g id="Group_38" data-name="Group 38">
                <path id="Path_33" data-name="Path 33" d="M0,0H24V24H0Z" fill="#7b8387" opacity="0"/>
                <path id="Path_34" data-name="Path 34" d="M7.41,15.41,12,10.83l4.59,4.58L18,14,12,8,6,14Z" class="svg-secondary-color"/>
            </g>
        </g>
    </svg>
</template>

<script>

export default {
    name: "arrowUpIcon",
    props: ['height', 'width'],
}
</script>



// WEBPACK FOOTER //
// src/common/components/svg/shared/arrowUpIcon.vue